import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const PinWheelLinkToken = gql`
  query pinwheelLinkToken($input: PinwheelLinkTokenInput) {
    pinwheelLinkToken(input: $input) {
      __typename
      ... on PinwheelLinkTokenSuccess {
        id
        token
        linkTokenId
        __typename
      }
      ... on PinwheelLinkTokenError {
        ...error
      }
    }
  }
  ${error}
`;

export default PinWheelLinkToken;
